import React from 'react';
import Modal from '../../../../component/modal/ModalTemplate';


class RefundFailModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }// end constructor
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (this.props.isOpen !== nextProps.isOpen)
    }// end CompUpdate
    render() {
        const { isOpen, handleClose } = this.props;
        return (
            <Modal
                className={`react-modal`}
                open={isOpen}
                handleClose={handleClose}
            >
                <div className='modal-body'>
                    <p>위약금, PG 수수료, 송금 비용, 결제 금액에 따라 추가 증여된 리워드의 금액을 제외하였을 때 환불 가능한 금액이 없습니다.</p>
                </div>
                <div className='modal-footer'>
                    <button className='btn btn-primary btn-md me-2' onClick={handleClose}>확인</button>
                </div>
            </Modal>
        )
    }// end render
} // end class


export default RefundFailModal;
